import { GISType } from "./gis-types";

export type GisEditParameters = {
  portalServer: string;
  restServer: string;
  type: string;
  id: number;
  activityNum: number; // If this is a resource, specify the resource-visit nmcris num
  readonly: boolean;
  userIsHPDORAdmin: boolean; // if not readonly, use this to limit admin functionality
  shapefileToJsonURL: string; // Portal endpoint to convert shapefiles to json
  baseLayerURL: string; // Interstates, highways, counties
  featureServerLayerURL: string; // map layer, for fetching shapes to edit
  createURL: string; // URL for endpoint to create a new drawn shape on the current "edit" layer
  editURL: string; // URL for endpoint to update a shape on the current "edit" layer
  deleteURL: string; // URL for endpoint to delete a shape on the current "edit" layer
  // layer list layers (non-edit layers)
  activityLayerUrl: string;
  hcpiLayerURL: string;
  districtLayerURL: string;
  siteLayerURL: string;
  registerLayerURL: string;
  covenantLayerURL: string;
};

export class GisEditContext {
  params: GisEditParameters;

  gisType: GISType;
  readonly: boolean;

  // This is included only to satiate typescript. This class should be deserialized fully when called by js interop.
  constructor(params: GisEditParameters) {
    if (params.portalServer == null)
      throw new Error(
        "Failed to construct GisEditContext, field portalServer was null",
      );
    if (params.restServer == null)
      throw new Error(
        "Failed to construct GisEditContext, field restServer was null",
      );
    if (params.type == null)
      throw new Error(
        "Failed to construct GisEditContext, field type was null",
      );
    if (params.id == null)
      throw new Error("Failed to construct GisEditContext, field Id was null");
    if (params.readonly == null)
      throw new Error(
        "Failed to construct GisEditContext, field readonly was null",
      );
    if (params.userIsHPDORAdmin == null)
      throw new Error(
        "Failed to construct GisEditContext, field userIsHPDORAdmin was null",
      );
    if (params.shapefileToJsonURL == null)
      throw new Error(
        "Failed to construct GisEditContext, field shapefileToJsonURL was null",
      );
    if (params.baseLayerURL == null)
      throw new Error(
        "Failed to construct GisEditContext, field baseLayerURL was null",
      );
    if (params.featureServerLayerURL == null)
      throw new Error(
        "Failed to construct GisEditContext, field featureServerLayerURL was null",
      );
    if (params.createURL == null)
      throw new Error(
        "Failed to construct GisEditContext, field createURL was null",
      );
    if (params.editURL == null)
      throw new Error(
        "Failed to construct GisEditContext, field editURL was null",
      );
    if (params.deleteURL == null)
      throw new Error(
        "Failed to construct GisEditContext, field deleteURL was null",
      );
    if (params.activityLayerUrl == null)
      throw new Error(
        "Failed to construct GisEditContext, field activityLayerUrl was null",
      );
    if (params.hcpiLayerURL == null)
      throw new Error(
        "Failed to construct GisEditContext, field hcpiLayerURL was null",
      );
    if (params.districtLayerURL == null)
      throw new Error(
        "Failed to construct GisEditContext, field districtLayerURL was null",
      );
    if (params.siteLayerURL == null)
      throw new Error(
        "Failed to construct GisEditContext, field siteLayerURL was null",
      );
    if (params.registerLayerURL == null)
      throw new Error(
        "Failed to construct GisEditContext, field registerLayerURL was null",
      );
    if (params.covenantLayerURL == null)
      throw new Error(
        "Failed to construct GisEditContext, field covenantLayerURL was null",
      );
    this.params = params;

    const _gisType = GISType.fromString(params.type);
    if (_gisType != null) {
      this.gisType = _gisType;
    } else {
      throw new Error("Not a Valid Type");
    }

    this.readonly = params.readonly;

    // NMCRIS-695: HCPI Districts should always be read only
    if (this.gisType === GISType.District) {
      this.readonly = true;
    }
  }
}
